import React from 'react';
import { Router, Route, IndexRoute, applyRouterMiddleware, browserHistory } from 'react-router';
import useScroll from 'react-router-scroll';
import App from 'views/app';
import Events from 'views/events';
import Event from 'views/event';
import RouteNotFound from 'views/routeNotFound';
import EventDetails from 'views/events/details';
import EventLead from 'views/events/eventLead';
import Leads from 'views/leads';
import Lead from 'views/lead';
import LeadDetails from 'views/leads/details';
import Venues from 'views/Venues';
import SearchResults from 'views/SearchResults';
import errorHandler from 'utils/errorHandler';

export default (
    <Router history={browserHistory} render={applyRouterMiddleware(useScroll())}>
        <Route path="/" component={errorHandler(App)}>
            <Route path="/results" component={errorHandler(SearchResults)} />

            <Route path="/events" component={errorHandler(Events)} />
            <Route path="/events/:eventId" component={errorHandler(Event)}>
                <IndexRoute component={errorHandler(EventDetails)} />
                <Route path="/events/:eventId/messages/:leadId" component={errorHandler(EventLead)} />
            </Route>

            <Route path="/leads" component={errorHandler(Leads)} />
            <Route path="/leads/:leadId" component={errorHandler(Lead)}>
                <IndexRoute component={errorHandler(LeadDetails)} />
            </Route>

            <Route path="/venues" component={errorHandler(Venues)} />
        </Route>

        <Route path="*" component={errorHandler(RouteNotFound)} />
    </Router>
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/routes.jsx